import {
  FilterMode,
  ProvinceStateCreateMutationVariables,
  ProvinceState_OrderBy,
  ProvinceState,
  SortOrder,
  ProvinceState_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const provinceStateService = {
  createOne: buildCreateOne(
    (provinceStateCreateVariables: ProvinceStateCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.provinceStateCreate(
          provinceStateCreateVariables
        );
        return result.provinceStateCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.provinceStateOne({ id });
    return result.provinceStateOne as ProvinceState;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: ProvinceState_OrderBy[] | null = null,
    filter: ProvinceState_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: ProvinceState_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.provinceStateListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.provinceStateListWithOffset
    ) as ProvinceState[];
    return { list, orderBy };
  },
};
